import React, { useEffect } from "react";

const Section = ({ title, children }) => (
  <div className="bg-white border rounded-2xl p-6 shadow-sm hover:shadow-lg transition duration-300">
    <h2 className="text-base md:text-lg font-semibold text-red-600 mb-3">
      {title}
    </h2>

    <div className="text-gray-700 text-sm md:text-base leading-relaxed space-y-2">
      {children}
    </div>
  </div>
);

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="w-full min-h-screen pt-28 bg-gradient-to-br from-gray-50 via-white to-red-50">

      {/* HEADER */}
      <div className="w-full bg-gradient-to-r from-red-600 to-red-500 text-white py-12 px-6 md:px-16">
        <h1 className="text-3xl md:text-4xl font-bold mb-2 text-center">
          Privacy Policy
        </h1>

        <p className="text-sm md:text-base opacity-90 text-center">
          MedrphaLab (ARMC PHARMA PRIVATE LIMITED)
        </p>
      </div>

      {/* CONTENT */}
      <div className="w-full px-6 md:px-16 py-10">
        <div className="grid gap-6 md:grid-cols-2">

          <Section title="1. Introduction">
            <p>
              This Privacy Policy governs the collection, use, storage, and disclosure
              of personal data of users who access the MedrphaLab platform.
            </p>
            <p>
              The Company complies with applicable laws including the IT Act, 2000
              and DPDP Act, 2023.
            </p>
          </Section>

          <Section title="2. Definitions">
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Personal Data:</strong> Identifiable individual data</li>
              <li><strong>Sensitive Data:</strong> Health, financial, and medical data</li>
              <li><strong>Processing:</strong> Collection, storage, and usage of data</li>
              <li><strong>Third Party:</strong> Labs and external partners</li>
            </ul>
          </Section>

          <Section title="3. Data Collection">
            <p>
              We collect personal information such as name, phone number, email,
              and health-related data required for service delivery.
            </p>
          </Section>

          <Section title="4. Use of Data">
            <ul className="list-disc pl-5">
              <li>To provide and improve services</li>
              <li>To process bookings and payments</li>
              <li>To communicate updates and notifications</li>
            </ul>
          </Section>

          <Section title="5. Data Sharing">
            <p>
              Data may be shared with diagnostic labs and service providers
              strictly for service fulfillment.
            </p>
          </Section>

          <Section title="6. Data Security">
            <p>
              We implement industry-standard security measures to protect your personal data.
            </p>
          </Section>

          <Section title="7. User Rights">
            <ul className="list-disc pl-5">
              <li>Access your data</li>
              <li>Request correction</li>
              <li>Request deletion</li>
            </ul>
          </Section>

          <Section title="8. Cookies">
            <p>
              We may use cookies to enhance user experience and analyze usage.
            </p>
          </Section>

          <Section title="9. Updates to Policy">
            <p>
              This Privacy Policy may be updated from time to time.
            </p>
          </Section>

          <Section title="10. Contact Information">
            <p>
              ARMC PHARMA PRIVATE LIMITED <br />
              Email: info@medrpha.com
            </p>
          </Section>

        </div>
      </div>
    </div>
  );
}